export default {
  linkText: {
    textDecorationLine: 'underline',
  },
};
